import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {FormattedMessage} from 'react-intl';
import {Alert} from 'react-bootstrap';
import LastOrganisationId from '../app/LastOrganisationId';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import AgentLink from '../fw/AgentLink.react';

export default class ScenarioPrerequisite extends React.Component {
	static propTypes = {
		channelsToConnect: PropTypes.array.isRequired,
		scenario: PropTypes.object.isRequired
	};

	static defaultProps = {
		channelsToConnect: []
	};

	needAgentChannels() {
		return this.props.channelsToConnect.filter(channel => Boolean(channel.channelDef.requiresAgent));
	}

	static hasInvitationId() {
		let params = queryString.parse(window.location.search || '') || {};

		return Boolean(params.invitationId);
	}

	static show(channelsToConnect) {
		return channelsToConnect.some(channel => Boolean(channel.channelDef.requiresAgent)) && !ScenarioPrerequisite.hasInvitationId();
	}

	static getTitle() {
		return (<FormattedMessage defaultMessage="Scenario requirement" id="channelWizard.Prerequisite.title" />);
	}

	static storeLinkExpectation(params) {
		localStorage.setItem("connection-link-expectation", JSON.stringify({
			time: Date.now(),
			...params
		}));
	}

	static getStoredOrganisation() {
		let data = localStorage.getItem("connection-link-expectation");

		if (data) {
			try {
				data = JSON.parse(data);

				let currentTimestamp = (new Date()).getTime();
				if (currentTimestamp - data.time < 60 * 60 * 1000) {
					data = data.organisationId;
				}
				else {
					data = null;
				}
			}
			catch (e) {
				data = null;
			}
		}

		return data;
	}

	static checkForExpectingInvitation() {
		let connectionLinkInvitation;
		let connectionLinkParams;

		try {
			connectionLinkInvitation = localStorage.getItem("connection-link-expectation");
			connectionLinkParams = JSON.parse(connectionLinkInvitation);
		}
		catch (e) {}

		if (!connectionLinkParams) {
			return false;
		}

		let currentTimestamp = (new Date()).getTime();

		if (currentTimestamp - connectionLinkParams.time < 60 * 60 * 1000) {
			return connectionLinkParams;
		}

		return false;
	}

	static redirectToScenarioIfNeeded(router, channelDefId) {
		let connectionLinkParams = ScenarioPrerequisite.checkForExpectingInvitation();
		if (location.search && connectionLinkParams && connectionLinkParams.channelDefId === channelDefId) {
			let path = urlMapping.getUrl(types['channels'], "scenario-apply", {
				organisation_id: connectionLinkParams.organisationId,
				urlFragment: connectionLinkParams.scenarioUrlFragment,
				scenario_id: connectionLinkParams.scenarioId
			});

			router.push(path + location.search);
		}
	}

	render() {
		let channels = this.needAgentChannels();
		let channelDef = channels[0].channelDef;

		ScenarioPrerequisite.storeLinkExpectation({
			scenarioId: this.props.scenario.realId,
			scenarioUrlFragment: this.props.scenario.urlFragment,
			channelDefId: channelDef.realId,
			organisationId: LastOrganisationId.get()
		});

		return (
			<Alert bsStyle="warning">
				<FormattedMessage defaultMessage="{channelDefName} needs to be connected from {dativeryAgent}. Install it, if not yet done, and connect {channelDefName} from there." id="ScenarioPrerequisite.message2" values={{
					channelDefName: channelDef.name,
					dativeryAgent: <AgentLink />
				}} />
			</Alert>
		);
	}
}
